export default __webpack_public_path__ + "static/media/MedhaKudaisya.6dc0e812.jpg";